import {
  InternalHourAction,
  InternalHourState,
} from 'store/aggregated/internalHour';
import { domainUtility } from 'utility';

const initialState: InternalHourState = { allIds: [], byId: {} };

const internalHourReducer = (
  state: InternalHourState = initialState,
  action: InternalHourAction,
): InternalHourState => {
  switch (action.type) {
    case 'aggregated/internalHour/ADD':
      return domainUtility.add(state, action.payload);
    case 'aggregated/internalHour/SET':
      return domainUtility.set(state, action.payload);
    case 'aggregated/internalHour/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'aggregated/internalHour/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'aggregated/internalHour/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default internalHourReducer;
